import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";
import { formatCurrency } from "@core/utils/filter";

// Notification
import router from "@/router";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useProjectsList() {
  // Use toast
  const toast = useToast();

  const refProjectListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: "invoice", class: 'sticky-column', label: "發票單號" },
    { key: "actions", class: 'sticky-column', label: "操作"},
    { key: "is_completed", label: "是否完成", sortable: true, class: 'sticky-column'},
    { key: "project_number", label: "編號", sortable: true },
    { key: "customer.user_number", label: "客戶編號"},
    { key: "project_status_id", label: "項目狀態" },
    { key: "name_cn", label: "單據抬頭", sortable: true },
    { key: "name", label: "系統帳號名稱", sortable: true },
    // { key: "customer.name_cn", label: "客戶名稱"},
    { key: "project_name" ,label: "項目名稱", sortable: true },
    { key: "address", label: "工程地址", sortable: true },
    { key: "project_description", label: "服務摘要", sortable: true },
    { key: "period", label: "預定工期", sortable: true },
    { key: "phone", label: "聯絡電話" },
    { key: "email", label: "電郵地址", sortable: true },
    { key: "amount", label: "總金額", sortable: true, formatter: formatCurrency },
    // { key: "payment_method_id", label: "付款狀態" },
    { key: "manager_id", label: "工程經理", sortable: true },
    { key: "users", label: "工程員工"},
    { key: "created_at", label: "創建日期", sortable: true },
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const projectsList = ref(null);

  const filter_invoice_id = ref(null);
  const filter_project_status_id = ref(null);
  const filter_customer_id = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refProjectListTable.value
      ? refProjectListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    refProjectListTable.value.refresh();
  };

  watch(
    [currentPage, perPage, searchQuery, filter_invoice_id, filter_project_status_id, filter_customer_id ],
    () => {
      refetchData();
    }
  );
  let init = true
  const fetchProjects = (ctx, callback) => {

    // 基於路由路徑的過濾邏輯
    if (init) {
      const currentPath = router.currentRoute.path;

      if (currentPath.includes('projects-in-progress')) {
        // 進行中項目：過濾顯示 project_status_id != 4 的記錄
        filter_project_status_id.value = 'not_quoting'; // 使用特殊值表示非報價中
      } else if (currentPath.includes('projects-in-quoting')) {
        // 報價中項目：過濾顯示 project_status_id == 4 的記錄
        filter_project_status_id.value = 4;
      }

      init = false;
    }
    store
      .dispatch("project/fetchProjects", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        invoice_id: filter_invoice_id.value,
        project_status_id: filter_project_status_id.value,
        customer_id: filter_customer_id.value,
      })
      .then((response) => {
        const { projects, total } = response.data;
        callback(projects);
        totalRow.value = total;
        projectsList.value = projects

      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取貸款清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const projectStatusesOptions = ref([]);
  const invoiceOptions = ref([]);
  const managerOptions = ref([]);
  const customerOptions = ref([]);

  const refetchOption = () => {
    store
      .dispatch("app/fetchOptionList", {
        project_statuses: true,
        // min_quotations: true,
        invoices: true,
        users: true,
        customers: true,
      })
      .then((response) => {
        projectStatusesOptions.value = response.data.project_statuses;
        invoiceOptions.value = response.data.invoices;
        managerOptions.value = response.data.users
        customerOptions.value = response.data.customers
      });
  };

  onMounted(() => {
    refetchOption();
  });

  return {
    fetchProjects,
    tableColumns,
    perPage,
    currentPage,
    totalRow,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    projectsList,
    refProjectListTable,
    ability,
    refetchData,
    filter_invoice_id,
    filter_project_status_id,
    filter_customer_id,
    projectStatusesOptions,
    invoiceOptions,
    managerOptions,
    customerOptions,
   
  };
}
